import { NavLink, useNavigate } from "react-router-dom";

export default function UserSidebar() {
  const navigate = useNavigate();

  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const channelId = user?.channelId;

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <aside className="user-sidebar">
      
      <div className="sidebar-logo">ShareVideo</div>

      {/* ===== SCROLLABLE AREA START ===== */}
      <div className="sidebar-scroll">

        {/* ================= USER MODE ================= */}
        <nav className="sidebar-nav">
          <NavLink to="/user/home">Home</NavLink>
          <NavLink to="/user/videos-feed">Explore</NavLink>
          <NavLink to="/user/shorts-feed">Shorts</NavLink>
          <NavLink to="/user/posts-feed">Posts</NavLink>

          {/* ? SONGS ADDED */}
          <NavLink to="/user/songs">Songs</NavLink>
        </nav>

        <hr style={{ margin: "20px 0" }} />

        {/* ================= CREATOR STUDIO ================= */}
        <div className="sidebar-section-title">
          Creator Studio
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/user/dashboard">Dashboard</NavLink>
          <NavLink to="/user/content">Content Manager</NavLink>

          {channelId && (
            <NavLink to={`/user/channel/${channelId}`}>
              My Channel
            </NavLink>
          )}

          <NavLink to="/user/analytics">Analytics</NavLink>
          <NavLink to="/user/monetization">Monetization</NavLink>
          <NavLink to="/user/withdraw">Withdraw</NavLink>

          <NavLink to="/user/profile">
            Profile
          </NavLink>

          <NavLink to="/user/settings">Settings</NavLink>
        </nav>

      </div>
      {/* ===== SCROLLABLE AREA END ===== */}

      <div className="sidebar-footer">
        <button onClick={handleLogout}>Logout</button>
      </div>

    </aside>
  );
}